import { render, staticRenderFns } from "./MatchReport.vue?vue&type=template&id=cde081a6&"
import script from "./MatchReport.vue?vue&type=script&lang=js&"
export * from "./MatchReport.vue?vue&type=script&lang=js&"
import style0 from "./MatchReport.vue?vue&type=style&index=0&id=cde081a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports